export default __webpack_public_path__ + "static/media/WhatsApp_Image_.3a53d1e6.jpeg";